<div class="icons-container" aria-label="Header notifications">
  @if (isUserLoggedIn && hasNotifications) {
    <div>
      <lwty-button-icon
        aria-label="View notifications"
        [icon]="'bell-unfilled'"
        (click)="toggleNotifications()" />
      @if (notificationsOpen) {
        <lc-notifications-panel
          [notifications]="notifications"
          (closePanelEvent)="closeNotifications()"
          (markNotificationAsReadEvent)="markNotificationAsRead($event)" />
      }
    </div>
  }
  <lwty-button-icon
    class="faq-button"
    data-testid="header-faq-button"
    theme="minimal"
    [icon]="'help-circle'"
    [ariaLabel]="'App.Faqs' | translate"
    (click)="goToFaqs()"
    (keydown.enter)="goToFaqs()" />
  <lq-languages-selector />
</div>
